import React from "react";
import PropTypes from "prop-types";
import { useTransactionData } from "@/context/transactionContext";
import { ReactComponent as HeaderLogo } from "@/assets/images/headerLogo.svg";
import { formatCurrency } from "@/utils";

function Header1xbet({ transactionData: dataFromProps, showAmount }) {
  const { transactionData: dataFromContext } = useTransactionData();
  const transactionData = dataFromProps || dataFromContext;

  return (
    <div className="flex items-center justify-between px-12 py-1 w-full relative bg-white border-b-2 border-lighter-gray border-opacity-60">
      <HeaderLogo className="size-[30px]" />
      {showAmount &&
        formatCurrency(
          transactionData?.merchant_request_amount,
          transactionData?.merchant_request_currency_iso,
          true,
        )}
    </div>
  );
}

Header1xbet.propTypes = {
  showAmount: PropTypes.bool,
  transactionData: PropTypes.shape({
    merchant: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
      checkout_hide_brand: PropTypes.bool,
    }),
  }),
};

Header1xbet.defaultProps = {
  transactionData: null,
};

export default Header1xbet;
